import React from 'react'

const Analytics = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path fill="#fff" d="M13.54 9.647h-3.146c-.434 0-.787.331-.787.74v8.873c0 .409.353.74.787.74h3.146c.434 0 .787-.331.787-.74v-8.874c0-.408-.353-.739-.787-.739zM7.72 13.412H3.943c-.521 0-.944.369-.944.823v4.942c0 .454.423.823.944.823h3.775c.521 0 .944-.369.944-.823v-4.942c0-.454-.423-.823-.944-.823zM20.147 4h-3.146c-.434 0-.787.358-.787.8v14.4c0 .442.353.8.787.8h3.146c.434 0 .787-.358.787-.8V4.8c0-.442-.353-.8-.787-.8z"/>
  </svg>
)

export default Analytics
